import { Link } from 'react-router-dom';
import { Shell } from '../components/Shell';
import './HowItWorksPage.css';

const blocks = [
  {
    key: 'modules',
    title: 'Modules',
    body:
      'Each module is a self-contained reading on one question or theme—clear structure, respectful tone, and cross-links when you want to go deeper.',
    cta: { to: '/browse', label: 'Browse modules' },
  },
  {
    key: 'journeys',
    title: 'Journeys',
    body:
      'Journeys order modules into a path (e.g. first-time exploration or clarity for Muslims). Your place is saved so you can resume calmly.',
    cta: { to: '/journeys', label: 'Open journeys' },
  },
  {
    key: 'questions',
    title: 'Questions hub',
    body:
      'Browse by tag and difficulty. Hard topics are labeled so you can choose when you are ready—without sensational framing.',
    cta: { to: '/browse', label: 'Explore topics' },
  },
  {
    key: 'search',
    title: 'Search',
    body:
      'One search across modules, journeys, and topics. Results note whether your words matched the title, summary, or both.',
    cta: { to: '/search', label: 'Search now' },
  },
  {
    key: 'study',
    title: 'Study & account',
    body:
      'Sign in to sync reading state, notes, and journey progress across sessions (where the backend is available).',
    cta: { to: '/study', label: 'Go to My Space' },
  },
  {
    key: 'compare',
    title: 'Compare',
    body:
      'Side-by-side themes (e.g. Christianity and Islam on Jesus) are presented for understanding differences, not for debate scoring.',
    cta: { to: '/compare/islam-christianity-jesus', label: 'Open compare' },
  },
];

export function HowItWorksPage() {
  return (
    <Shell>
      <div className="wi-how-it-works">
        <section className="wi-guide-hero" aria-labelledby="wi-guide-hero-title">
          <div className="wi-guide-hero__veil" aria-hidden />
          <div className="wi-guide-hero__inner">
            <p className="wi-guide-kicker">Guide</p>
            <h1 id="wi-guide-hero-title">How this site works</h1>
            <p className="wi-guide-lede">
              Why Islam is built for careful reading: structured content, transparent cross-links, and a single search across the library.
            </p>
            <Link to="/browse" className="wi-guide-cta" aria-label="Browse the library">
              Browse the library
            </Link>
          </div>
        </section>

        <div className="wi-guide-scenes">
          {blocks.map((b, i) => (
            <section
              key={b.key}
              className={`wi-guide-scene wi-guide-scene--${b.key}${i % 2 === 1 ? ' wi-guide-scene--right' : ''}`}
              aria-label={b.title}
            >
              <div className="wi-guide-scene__veil" aria-hidden />
              <div className="wi-guide-scene__inner">
                <div className="wi-guide-scene__copy">
                  <h2>{b.title}</h2>
                  <p>{b.body}</p>
                  <Link to={b.cta.to} className="wi-guide-scene__cta" aria-label={b.cta.label}>
                    {b.cta.label}
                  </Link>
                </div>
              </div>
            </section>
          ))}
        </div>
      </div>
    </Shell>
  );
}
